import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SearchComponent } from './components/search/search.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { EnvironmentLoaderService } from './services/environment-loader.service';
import { AuthService } from './auth.service';
import { CredentialsInterceptor } from './interceptors/credentials.interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './modules/material/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CreateServiceordreComponent } from './components/create-serviceordre/create-serviceordre.component';
import {
  DateAdapter,
  MatNativeDateModule,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { DkDateAdapter } from './adapters/DkDateAdapter';
import { LoaderComponent } from './components/shared/loader/loader.component';
import { CustomIconService } from './services/custom-icon.service';
import { MomentModule } from 'ngx-moment';
import 'moment/locale/da';
import { registerLocaleData, DatePipe } from '@angular/common';
import localeDA from '@angular/common/locales/da';
import { VersionComponent } from './components/shared/version/version.component';
import { CharacterCountComponent } from './components/shared/character-count/character-count.component';
import { EnvironmentComponent } from './components/shared/environment/environment.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { CancelServiceordreComponent } from './components/cancel-serviceordre/cancel-serviceordre.component';
import { PartnerDialogComponent } from './components/shared/partner-dialog/partner-dialog.component';
import { dkPhoneNumberPipe } from './pipes/dk-phonenumber';
import { OAuthModule } from 'angular-oauth2-oidc';


export function environmentProviderFactory(provider: EnvironmentLoaderService, authService: AuthService) {
  return async () => {
    await provider.load();
    return authService.init();
  };
}

registerLocaleData(localeDA);

@NgModule({
  declarations: [
    AppComponent,
    SearchComponent,
    CreateServiceordreComponent,
    LoaderComponent,
    VersionComponent,
    CharacterCountComponent,
    EnvironmentComponent,
    ConfirmDialogComponent,
    CancelServiceordreComponent,
    PartnerDialogComponent,
    dkPhoneNumberPipe,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    BrowserAnimationsModule,
    MatNativeDateModule,
    MomentModule,
    OAuthModule.forRoot({
      resourceServer: {
        sendAccessToken: true,
      },
    }),
  ],
  providers: [
    DatePipe,
    CustomIconService,
    {
      provide: APP_INITIALIZER,
      useFactory: environmentProviderFactory,
      deps: [EnvironmentLoaderService, AuthService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CredentialsInterceptor,
      multi: true,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'da-DK' },
    { provide: LOCALE_ID, useValue: 'da-DK' },
    { provide: DateAdapter, useClass: DkDateAdapter },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
